import { jsx as o, Fragment as i } from "react/jsx-runtime";
import { VARIANT_TO_SPINNER as m } from "./index.es2372.js";
import { Spinner as a } from "./index.es64.js";
const I = ({
  isLoading: t,
  variant: n,
  testId: r
}) => t ? /* @__PURE__ */ o(a, { variant: m[n], testId: `${r}-icon-loading` }) : /* @__PURE__ */ o(i, {});
export {
  I as ButtonLoadingIndication
};
//# sourceMappingURL=index.es676.js.map
